const PRODUCTION_ANALYTICS_HOST = 'microplasticsapp.com'

/**
 * Keep the production analytics projects scoped to the canonical public host.
 * Vercel preview and generated deployment hostnames can contain the same
 * production browser tokens, so build-time token presence is not a safe gate.
 */
export function isProductionAnalyticsHost(hostname: string | undefined): boolean {
  return hostname?.trim().toLowerCase().replace(/\.$/, '') === PRODUCTION_ANALYTICS_HOST
}
